import { createSharedComposable, useEventListener } from "@vueuse/core";
import { computed, ref } from "vue";

enum InputType {
  POINTER,
  KEYBOARD,
}

const useLastInputType = () => {
  const lastInputType = ref<InputType>(InputType.POINTER);
  const isPointer = computed(() => lastInputType.value === InputType.POINTER);
  const isKeyboard = computed(() => lastInputType.value === InputType.KEYBOARD);

  useEventListener(
    window,
    ["scroll", "mousemove", "wheel", "touchstart", "touchmove", "keydown"],
    (evt: Event) => {
      lastInputType.value = evt.type === "keydown" ? InputType.KEYBOARD : InputType.POINTER;
    },
    { capture: true, passive: true }
  );

  return { lastInputType, isPointer, isKeyboard };
};

export default createSharedComposable(useLastInputType);
